import { TweenMax } from 'gsap';
import NineSlicePlane = PIXI.mesh.NineSlicePlane;
import { Animation } from '../../Animations/Animation';
import { UIButton } from './UIButton';
import Texture = PIXI.Texture;
import { disableWebGL } from '../../../Utils/Platform';

export enum ButtonColors {
    GREEN = 0x26e500,
    BLUE = 0x2cbaff,
    RED = 0xff4133,
    PURPLE = 0xf600ff,
    PINK = 0xff4ca6,
    ORANGE = 0xff7f00,
    GREY = 0xb2b2b2,
    DARK_GREEN = 0x12b27d,
}

export class NineSliceButton extends UIButton {
    protected nineSlice: NineSlicePlane;

    constructor(color: ButtonColors, width: number, height: number) {
        super('');
        const texture: Texture = PIXI.utils.TextureCache['commonui/button-bg'];

        this.createNineSlice(texture, color, width, height);

        // We need to re-create the nine slice on canvas with a cloned texture because some planes
        // are cached and not updated properly.
        if (disableWebGL()) {
            texture.on('update', () => {
                this.createNineSlice(texture, color, width, height);
            });
        }
    }

    protected createNineSlice(
        texture: Texture,
        color: ButtonColors,
        width: number,
        height: number
    ) {
        if (this.nineSlice) {
            this.nineSlice.destroy();
            texture = texture.clone();
        }
        this.nineSlice = new NineSlicePlane(texture, 40, 40, 40, 40);
        this.nineSlice.tint = color;
        this.nineSlice.width = width;
        this.nineSlice.height = height;
        this.nineSlice.pivot.set(width / 2, height / 2);
        this.createDisableAnimation();
        this.addChildAt(this.nineSlice, 0);
    }

    protected createDisableAnimation() {
        this.disableAnimation = new Animation({});
        if (!this.nineSlice) {
            return;
        }
        this.disableAnimation.add(
            TweenMax.to(this.nineSlice, 0.1, { pixi: { tint: ButtonColors.GREY } })
        );
    }
}
